




































































































































































































































































































import { Component, Prop, Watch } from "vue-property-decorator";
import { mixins } from "vue-class-component";
import NotificationEvent from "@/resources/mixins/notifications/notificationEvent";
import { i18n } from "@/resources/locales";
import Sortable from "sortablejs";
@Component({
  name: "group-users-component",
})
export default class GroupUsersComponent extends mixins(NotificationEvent) {
  [x: string]: any;
  @Prop({ default: true }) isCampus;
  openModal = false;
  active = "groups";
  name = "";
  description = "";
  loader = false;
  loading = false;
  loadingEdit = false;
  loadingSetUsersGroup = false;
  loadingGetUserCampus = false;
  editGroup = false;
  editUsers = false;
  selectGroup = null;
  usersGroup = [];
  usersList = [];
  sendUsersGroup = [];
  page = 1;
  lastScroll = 0;
  lastPage = 0;
  @Watch("active")
  updateNavbar(): void {
    if (this.active == "groups" || this.active == "createGroup") {
      this.editGroup = false;
      this.editUsers = false;
      this.selectGroup = null;
    }
  }
  groups = [];
  mounted() {
    this.getGroups();
  }
  get superSpace(): any {
    return this.$store.getters["SuperSpaceStore/getSuperSpace"];
  }
  getGroups() {
    this.loader = true;
    const space = this.$store.getters["SpaceStore/getSpace"];
    this.$store.dispatch("SpaceStore/getGroupAction", {
      superSpaceId: space ? space.superSpace.id : this.superSpace.id,
      callback: (response) => {
        this.groups = [...this.groups, ...response.data];
        this.loader = false;
      },
      callbackError: (error) => {
        console.log("TTT getGroups KO ", error);
        this.loader = false;
      },
    });
  }
  async getUsersGroup(id: number) {
    this.$store.dispatch("SpaceStore/getUsersGroupAction", {
      groupId: id,
      callback: (response) => {
        this.getUserCampus();
        this.usersGroup = response.data.superSpaceUsers;
        this.sendUsersGroup = [
          ...this.sendUsersGroup,
          ...response.data.superSpaceUsers,
        ];
        setTimeout(() => {
          let inGroup = document.getElementById("inGroup");
          let inCampus = document.getElementById("inCampus");

          Sortable.create(inGroup, {
            group: "shared",
            sort: true,
            onEnd: (event) => {
              if (event.to.id === "inCampus") {
                let item = event.item;
                let itemId = item.getAttribute("data-id");
                this.sendUsersGroup = this.sendUsersGroup.filter(
                  (i) => i.id != itemId
                );
              }
            },
          });

          Sortable.create(inCampus, {
            group: "shared",
            sort: false,
            onEnd: (event) => {
              if (event.to.id === "inGroup") {
                let item = event.item;
                let itemId = item.getAttribute("data-id");
                const user = this.usersList.find((i) => i.id == itemId);
                this.sendUsersGroup.push(user);
              }
            },
          });
        }, 2000);
      },
      callbackError: (error) => {
        console.log("TTT getUsersGroup KO ", error);
      },
    });
  }
  async getUserCampus() {
    const space = this.$store.getters["SpaceStore/getSpace"];
    if (space)
      this.$store.dispatch(
        "SpaceStore/getSpacesUsersByOrderNameAndLastNameAction",
        {
          superSpaceId: space ? space.superSpace.id : this.superSpace.id,
          page: this.page,
          callback: (response) => {
            this.lastPage = response.headers["pagination-last-page"];
            let ids = this.createArrayUsersIds();
            const arrayClear = response.data.filter(
              (object) => !ids.includes(object.id)
            );
            this.usersList = [...this.usersList, ...arrayClear];
            this.loadingGetUserCampus = false;
          },
          callbackError: (error) => {
            console.log("TTT getUserCampus KO ", error);
            this.loadingGetUserCampus = false;
          },
        }
      );
  }
  setUsersGroup() {
    this.loadingSetUsersGroup = true;
    this.$store.dispatch("SpaceStore/setUsersGroupAction", {
      groupId: this.selectGroup.id,
      data: { superSpaceUsersIds: this.createArrayUsersIds() },
      callback: (response) => {
        let replaceObject = this.groups.find(
          (objetc) => objetc.id === response.data.id
        );
        if (replaceObject) replaceObject.totalUsers = response.data.totalUsers;
        this.loadingSetUsersGroup = false;
        this.onSuccess(
          i18n.t("notifications.titles.success"),
          i18n.t("notifications.descriptions.editGroup")
        );
      },
      callbackError: (error) => {
        console.log("TTT setUsersGroup KO ", error);
        this.loadingSetUsersGroup = false;
      },
    });
  }
  createArrayUsersIds() {
    let arrayIds = [];
    this.sendUsersGroup.forEach((element) => {
      arrayIds.push(element.id);
    });
    return arrayIds;
  }
  createGroup() {
    this.loading = true;
    const space = this.$store.getters["SpaceStore/getSpace"];
    this.$store.dispatch("SpaceStore/createGroupAction", {
      superSpaceId: space ? space.superSpace.id : this.superSpace.id,
      data: {
        name: this.name,
        description: this.description,
      },
      callback: (response) => {
        this.groups.push(response.data);
        this.loading = false;
        this.name = "";
        this.description = "";
        this.onSuccess(
          i18n.t("notifications.titles.success"),
          i18n.t("notifications.descriptions.createGroup")
        );
      },
      callbackError: (error) => {
        console.log("TTT createGroup KO ", error);
        this.loading = false;
      },
    });
  }
  sendEditGroup() {
    this.loadingEdit = true;
    this.$store.dispatch("SpaceStore/editGroupAction", {
      groupId: this.selectGroup.id,
      data: {
        name: this.selectGroup.name,
        description: this.selectGroup.description,
      },
      callback: (response) => {
        this.loadingEdit = false;
        let replaceObject = this.groups.find(
          (objetc) => objetc.id === response.data.id
        );
        if (replaceObject) replaceObject = response.data;
        this.onSuccess(
          i18n.t("notifications.titles.success"),
          i18n.t("notifications.descriptions.editGroup")
        );
      },
      callbackError: (error) => {
        console.log("TTT sendEditGroup KO ", error);
        this.loadingEdit = false;
      },
    });
  }
  activarEditGroup(data: any) {
    this.selectGroup = data;
    this.active = "editGroup";
    this.editGroup = true;
    this.clearTooltip();
  }
  async activarEditUsers(data: any) {
    this.usersList = [];
    this.sendUsersGroup = [];
    this.usersGroup = [];
    this.page = 1;
    await this.getUsersGroup(data.id);
    this.onScrollEvent();
    this.selectGroup = data;
    this.active = "editUsers";
    this.editUsers = true;
    this.clearTooltip();
  }
  deleteGroup(id: number) {
    this.loader = true;
    this.$store.dispatch("SpaceStore/removeGroupAction", {
      groupId: id,
      callback: (response) => {
        let newGroup = this.groups.filter((object) => object.id !== id);
        if (newGroup) this.groups = newGroup;
        this.loader = false;
        this.onSuccess(
          i18n.t("notifications.titles.success"),
          i18n.t("notifications.descriptions.removeGroup")
        );
      },
      callbackError: (error) => {
        console.log("TTT deleteGroup KO ", error);
        this.loader = false;
      },
    });
  }
  clearTooltip() {
    const tooltip = document.getElementsByClassName("vs-tooltip");
    if (tooltip)
      while (tooltip.length > 0) {
        tooltip[0].parentNode.removeChild(tooltip[0]);
      }
  }
  onScrollEvent() {
    const userList = document.getElementById("inCampus");
    if (userList) {
      userList.addEventListener("scroll", () => {
        const a = userList.scrollTop;
        const b = userList.scrollHeight - userList.clientHeight;
        if (this.lastScroll < 0.4 && a / b > 0.4) {
          if (!this.loadingGetUserCampus) {
            this.loadingGetUserCampus = true;
            this.page = this.page + 1;
            if (this.page <= this.lastPage) this.getUserCampus();
          }
        }
      });
    } else {
      setTimeout(() => {
        this.onScrollEvent();
      }, 1000);
    }
  }
}
